// todo - test this func

export async function safeParseResponse(response) {
  try {
    return response?.json();
  } catch (e) {
    console.error(`safeParse() ${e}`);
    return null;
  }
}